import AbstractCommManager from "../AbstractCommManager";
import WebsocketConnection from "../WebsocketConnection";
import { __ConnectionManager, __Store } from "../../core";
import {
  getLoginCommand,
  getInitCommnand,
  getEndPoint,
  getHearthbeatCommand,
  getBalanceCommand,
  getPlaceBetCommand,
  getBetsCommand,
  getSubscriptionCommand,
  getLastResultsCommand,
  getFailedBetsCommand,
} from "./connection.Marlipin.utils";
import {
  action_normalizeResponseBroadcast,
  action_normalizeResponseMarlipin,
} from "./connection.Marlipin.response";

class MarlipinConnection extends AbstractCommManager {
  public getConnectionStrategy(
    onReady: () => {},
    onClose: () => {}
  ): WebsocketConnection {
    const URL = getEndPoint();
    return new WebsocketConnection({ URL, onReady, onClose });
  }

  public normalizeResponse(payload: any): void {
    action_normalizeResponseMarlipin(payload)(__Store.dispatch);
  }

  public normalizeBroadcastResponse(payload: any): void {
    action_normalizeResponseBroadcast(payload)(__Store.dispatch);
  }

  public appReload(): void {
    //todo
  }

  public rgsLogin(): void {
    __ConnectionManager.runCommand(getLoginCommand(false));
  }

  public rgsInit(sessionID: any): void {
    __ConnectionManager.runCommand(getInitCommnand(sessionID));
  }

  public getHeartbeatPayload(): any {
    return getHearthbeatCommand();
  }

  public buyBonus(): void {
    //todo
  }

  public updateBalance(): void {
    __ConnectionManager.runCommand(getBalanceCommand());
  }

  public placeBet(_numbers: any[]): void {
    __ConnectionManager.runCommand(getPlaceBetCommand(_numbers));
  }

  public getBets(): void {
    __ConnectionManager.runCommand(getBetsCommand());
  }

  public subscription(_numbers: any[], _subscriptions: number): void {
    __ConnectionManager.runCommand(
      getSubscriptionCommand(_numbers, _subscriptions)
    );
  }

  public lastResults(): void {
    __ConnectionManager.runCommand(getLastResultsCommand());
  }

  public failedBets(): void {
    __ConnectionManager.runCommand(getFailedBetsCommand());
  }
}

export default MarlipinConnection;
